import { render, staticRenderFns } from "./Flight.vue?vue&type=template&id=89e83774"
import script from "./Flight.vue?vue&type=script&lang=js"
export * from "./Flight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports